import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react";
import { AnimatePresence, easeOut, motion } from "framer-motion";
import { classNames } from "../../helpers/classNames";
import { Fragment } from "react";

export default function Accordian({
  buttonClass,
  contentClass,
  data = [],
  className,
}) {
  return (
    <div className="w-full">
      <div
        className={classNames(
          "mx-auto w-full rounded-2xl bg-white space-y-2",
          className
        )}
      >
        {data &&
          Array.isArray(data) &&
          data?.map((item, i) => (
            <Disclosure key={i?.toString()} as={"div"}>
              {({ open }) => (
                <>
                  <DisclosureButton
                    className={classNames(
                      "flex w-full justify-between rounded-md bg-surface-04 px-4 py-2 text-left text-sm font-medium hover:bg-surface-04/30 transition-all duration-150 items-center",
                      buttonClass,
                      item.buttonClass
                    )}
                  >
                    {item?.title}
                    <i
                      className={classNames(
                        "ml-auto",
                        open ? "fa-solid fa-angle-up" : "fa-solid fa-angle-down"
                      )}
                    ></i>
                  </DisclosureButton>
                  <div
                    className={classNames(
                      "overflow-hidden transition-all duration-300",
                      open ? "max-h-[2000px]" : "max-h-0"
                    )}
                  >
                    <AnimatePresence>
                      <DisclosurePanel static as={Fragment}>
                        <motion.div
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1 }}
                          exit={{ opacity: 0 }}
                          transition={{ duration: 0.2, ease: easeOut }}
                          className="origin-top"
                        >
                          <div
                            className={classNames(
                              "px-4 pb-2 pt-4 text-sm",
                              contentClass,
                              item.contentClass
                            )}
                          >
                            {item?.content}
                          </div>
                        </motion.div>
                      </DisclosurePanel>
                    </AnimatePresence>
                  </div>
                </>
              )}
            </Disclosure>
          ))}
      </div>
    </div>
  );
}
